(function($) {
    $(document).ready(function () {
        var wraps = $('.section.info_section');
        var destination = $('.section.main_content .below_the_content');
        if (destination.length) {
            wraps.each(function () {
                var wrap = $(this);
                var holder = wrap.find('.holder');
                if (holder.length) {
                    holder.children().appendTo(destination);
                }
            });
        }
    });
})(jQuery);